import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import * as React from 'react'

type DeleteDialogProps = {
  inUseCount: number
  optionIndex?: number
  onClose: () => void
  onDelete: () => void
  onDeactivate: () => void
}

export function DeleteDialog(props: DeleteDialogProps) {
  const { inUseCount, optionIndex, onClose, onDelete, onDeactivate } = props

  const open = optionIndex !== undefined

  const recs = `${inUseCount === 1 ? 'record' : 'records'}`

  return (
    <Dialog open={open}>
      <DialogTitle>Remove Option</DialogTitle>

      <DialogContent>
        <DialogContentText>
          This option is in use by {inUseCount} {recs}. Deleting it will result
          in data loss.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onDeactivate}>Deactive Instead</Button>
        <Button onClick={onDelete} variant="contained">
          Delete Anyway
        </Button>
      </DialogActions>
    </Dialog>
  )
}
